import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Dialog, Typography } from '@mui/material';
import { styled } from '@mui/system';
import _ from 'lodash';
import { addDays, compareDate, convert2Date, formatDate, MOMENT_FORMAT } from "../../common/utils/date";
import { settingServ, userServ } from '../../services';
import { KEY_SETTING, SOURCE, TARGET } from './const';

export function parseJson(jsonStr, isArr = false) {
  let ret = {}
  if (isArr) {
    ret = []
  }
  try {
    ret = JSON.parse(jsonStr)
  } catch (ex) {
    // console.log(ex)
  }
  return ret
}

/**
 * Genergrate unique id
 * 
 * @returns 
 */
export const genGuid = () => {
  let s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}


/**
 * Get user info
 * @returns 
 */
export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('USER'));
}

export const locations = (substring, string) => {
  var a = [], i = -1;
  while ((i = string.indexOf(substring, i + 1)) >= 0) a.push(i);
  return a;
}

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
   * Update action layout
   *
   * @param {*} actions
   */
export const updateFlexLayoutModel = (flexLayoutModel, actions) => {
  flexLayoutModel.current.doAction(actions);
};


/**
 * Set local storage
 * 
 * @param {*} key 
 * @param {*} value 
 */
export const setLocalstorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Get local store
 * 
 * @param {*} key 
 * @returns 
 */
export const getLocalstorage = (key) => {
  let val = localStorage.getItem(key);

  if (val) {
    val = JSON.parse(localStorage.getItem(key));
  } else {
    val = '';
  }
  return val;
}

export const findLocationTreeData = (datas) => {
  // Find parent id for child
  for (const data of datas) {
    const members = data.members;
    for (const memId of members) {
      const index = datas.findIndex(x => x.id === memId);
      if (index >= 0) {
        datas[index].parent_id = data.id;
      }
    }
  }

  // Find parent level 1 (not has parent_id)
  const result = [];
  for (const data of datas) {
    if (!data?.parent_id) {
      result.push({
        id: data.id,
        label: `[${data.id}] ${data.name}`,
        props: data
      })
    }
  }

  // Find child for parent
  for (const item of result) {
    item.all_child_ids = [item.id];
    findChildMember(datas, item, item);
  }

  return result;
}

const findChildMember = (datas, parent, itemLv1) => {
  for (const data of datas) {
    if (parent.id === data.parent_id) {
      const item = {
        id: data.id,
        label: `[${data.id}] ${data.name}`,
        parent_id: data.parent_id,
        props: data
      };

      itemLv1.all_child_ids = [...itemLv1.all_child_ids || [], data.id];

      parent.children = [
        ...parent.children || [],
        item
      ]

      if (data.members.length > 0) {
        findChildMember(datas, item, itemLv1)
      }
    }
  }
}
export const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}


export const DialogRightStyled = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    "& div[role='dialog']": {
      position: "absolute",
      right: 0,
      top: 0,
      margin: 0,
      maxHeight: "calc(100% - 0px)",
    },
  },

  "& .content": {
    width: "500px",
    height: "100vh",
  },

  "& .bot-acts": {
    display: "flex",
    justifyContent: "space-between",
    padding: 10,
  },
}));


/**
 * Render status icon
 * 
 * @param {*} style 
 * @returns 
 */
export const renderFiberManualRecordIcon = (style) => {
  return <FiberManualRecordIcon className="immerse-status-active" fontSize="small" style={ style } />
}

/**
 * Render link text
 * 
 * @param {*} val 
 * @returns 
 */
export const renderLink = (val) => {
  return (
    <Typography className="immerse-table-link" style={{paddingLeft:8}}>
          {val}
    </Typography>
  )
}

export const renderLinkWithStatus = (style, val) => {
  return (
    <div style={{display:'flex'}}>
      { renderFiberManualRecordIcon(style) }
      { renderLink(val) }
    </div>
  )
}

export const checkSessionTimeout = () => {
  
}

export const saveParamMode = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let source = params.get(TARGET);
  const state = params.get('state')

  // if (!source) {
  //   source = SOURCE.PPRS;
  // }
  !state && setLocalstorage(TARGET, source || 'pprs');
}
